/*
  Asset: ss-promise.js
  Component: Solid Stash Promise accordion (Web Component)
  
  Follows the same pattern as Flow's other Web Components
  (e.g. component-collapsible-button.js, component-product-information.js).
  Loaded once via safe-load-scripts in template--product.liquid.
*/
 
if (!customElements.get('ss-promise-accordion')) {
  class SsPromiseAccordion extends HTMLElement {
    connectedCallback() {
      this._trigger = this.querySelector('.ss-promise__trigger');
      this._content = this.querySelector('.ss-promise__content');
 
      if (this._trigger) {
        this._trigger.addEventListener('click', this._toggle.bind(this));
      }
    }
 
    disconnectedCallback() {
      if (this._trigger) {
        this._trigger.removeEventListener('click', this._toggle.bind(this));
      }
    }
 
    _toggle() {
      const isOpen = this._trigger.getAttribute('aria-expanded') === 'true';
      this._trigger.setAttribute('aria-expanded', String(!isOpen));
      this._content.hidden = isOpen;
    }
  }
 
  customElements.define('ss-promise-accordion', SsPromiseAccordion);
}
 